import { render } from "./NotFoundPage.vue?vue&type=template&id=8120567e&scoped=true&ts=true"
import script from "./NotFoundPage.vue?vue&type=script&lang=ts"
export * from "./NotFoundPage.vue?vue&type=script&lang=ts"

import "./NotFoundPage.vue?vue&type=style&index=0&id=8120567e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8120567e"]])

export default __exports__